import { createAction } from "@reduxjs/toolkit";

export type RankingMetric = "total" | "chips" | "exp";

export const rankingsRequest = createAction<{
  _start?: number;
  _end?: number;
}>("rankings/general/request");

export const rankingsSuccess = createAction<{
  items: any[];
  total: number;
}>("rankings/general/success");

export const rankingsFailure = createAction<string>("rankings/general/failure");

export const rankingsByPeriodRequest = createAction<{
  period: "Daily" | "Weekly" | "Monthly";
  _start?: number;
  _end?: number;
}>("rankings/byPeriod/request");
export const rankingsByPeriodSuccess = createAction<{
  items: any[];
  period: "Daily" | "Weekly" | "Monthly";
}>("rankings/byPeriod/success");
export const rankingsByPeriodFailure = createAction<string>(
  "rankings/byPeriod/failure",
);

export const rankingsTournamentsRequest = createAction<{
  _start?: number;
  _end?: number;
}>("rankings/tournaments/request");

export const rankingsTournamentsSuccess = createAction<{
  items: any[];
  total: number;
  endAt: string | null;
  now: string | null;
  reward: number;
  personal: any | null;
}>("rankings/tournaments/success");
export const rankingsTournamentsFailure = createAction<string>(
  "rankings/tournaments/failure",
);
